module.exports = __webpack_public_path__ + "img/standard-trigger.32f970d8.svg";